var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatistics({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1696816771625,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 57208,
    width: 64,
    height: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M897.4 892.4h-72.6c-20.6 0-37.5-16.9-37.5-37.5V608.4c0-20.6 16.9-37.5 37.5-37.5h72.6c20.6 0 37.5 16.9 37.5 37.5V855c0 20.6-16.9 37.4-37.5 37.4z",
    fill: "currentColor",
    "p-id": 57209,
    "data-spm-anchor-id": "a313x.search_index.0.i105.5caf3a81aFGzSu",
    className: "selected"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M659.2 892.4h-72.6c-20.6 0-37.5-16.9-37.5-37.5V330.4c0-20.6 16.9-37.5 37.5-37.5h72.6c20.6 0 37.5 16.9 37.5 37.5V855c-0.1 20.6-16.9 37.4-37.5 37.4z",
    fill: "#dcdcdc",
    "p-id": 57210,
    "data-spm-anchor-id": "a313x.search_index.0.i100.5caf3a81aFGzSu",
    className: ""
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M420.9 892.4h-72.6c-20.6 0-37.5-16.9-37.5-37.5V82.7c0-20.6 16.9-37.5 37.5-37.5h72.6c20.6 0 37.5 16.9 37.5 37.5V855c-0.1 20.6-16.9 37.4-37.5 37.4z",
    fill: "currentColor",
    "p-id": 57211,
    "data-spm-anchor-id": "a313x.search_index.0.i104.5caf3a81aFGzSu",
    className: "selected"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M182.6 892.4H110c-20.6 0-37.5-16.9-37.5-37.5V506.3c0-20.6 16.9-37.5 37.5-37.5h72.6c20.6 0 37.5 16.9 37.5 37.5V855c0 20.6-16.9 37.4-37.5 37.4z",
    fill: "#dcdcdc",
    "p-id": 57212,
    "data-spm-anchor-id": "a313x.search_index.0.i101.5caf3a81aFGzSu",
    className: ""
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.3 939.7h1022.2v37.5H0.3z",
    fill: "currentColor",
    "p-id": 57213,
    "data-spm-anchor-id": "a313x.search_index.0.i106.5caf3a81aFGzSu",
    className: "selected"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatistics);
export default __webpack_public_path__ + "static/media/statistics.0090a7864fcc5a328267736f8f699dff.svg";
export { ForwardRef as ReactComponent };